<template>
    <div id="app-container">

            <!-- Content -->
            <transition
                    name="fade"
                    mode="out-in"
            >
                <router-view></router-view>
            </transition>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

    export default {
        beforeMount() {
            this.setMetaData();
            this.setCarrier();
        },
        computed: {
            ...mapGetters(["carrierDetails", "isBusinessAccount"]),
        },

        methods: {
            ...mapActions(['setCarrier']),

            setMetaData() {
                if (process.env.VUE_APP_PARTNER_BUSINESS_NAME) {
                    document.title = process.env.VUE_APP_PARTNER_BUSINESS_NAME;
                } else {
                    document.title = process.env.VUE_APP_PARTNER_NAME;
                }

                let icons = this.carrierDetails.icons;
                if(icons) {
                    for (let iconKey in icons) {
                        let element = document.getElementById(iconKey);
                        if(iconKey === "meta-msapplication-tile-color" || iconKey === "meta-theme-color") {
                            element.content = icons[iconKey];
                            continue;
                        }
                        element.href = icons[iconKey];
                    }
                }
            }
        }
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

	/* IE11 */
	@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
		.fade-enter-active,
		.fade-leave-active,
		.fade-enter {
			opacity: 1;
			transition: none;
		}
	}

    #chat-widget-container {
        display: none;
    }
</style>